module.exports = __webpack_public_path__ + "static/media/add-logo-tablet-en.bd10dd6f.webp";